import React, { useState } from 'react';

import { Container, Typography, Button, Input, Box } from '@mui/material';
import { useAccount } from 'wagmi';
import { Oval } from 'react-loader-spinner';

import theme from '../../theme';
import { requestToken } from '../../lib/utils/requestToken';
import { getTxExplorer } from '../../lib/utils/explorer';

const Faucet: React.FC = () => {
  const { address } = useAccount();
  const [txhash, setTxhash] = useState('');
  const [isGettingFaucet, setIsGettingFaucet] = useState(false);

  const handleTokenRequest = async (address: string) => {
    setIsGettingFaucet(true);
    const hash = await requestToken(address);
    if (hash) setTxhash(hash);
    setIsGettingFaucet(false);
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        [theme.breakpoints.down('md')]: {
          px: 0,
        },
      }}
    >
      <Typography
        variant="h5"
        component="h2"
        gutterBottom
        sx={{ textAlign: 'center', mb: 3 }}
      >
        Arbitrum Testnet Faucet
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '8px',
          [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          },
        }}
      >
        <Input
          disableUnderline
          sx={{
            width: '80%',
            flexGrow: 1,
            fontSize: 20,
            fontWeight: 500,
            color: theme.palette.text.primary,
            '&::placeholder': {
              color: theme.palette.text.disabled,
            },
            border: '1px solid #11151e',
            borderRadius: '5px',
            px: 2,
            py: 0.5,
            [theme.breakpoints.down('md')]: {
              width: '100%',
              py: 0.2,
            },
          }}
          placeholder="Connect your wallet"
          disabled
          value={address}
        />
        <Button
          onClick={() => handleTokenRequest(address as string)}
          variant="contained"
          disabled={!address}
          sx={{
            px: 4,
            [theme.breakpoints.down('md')]: {
              width: '100%',
              py: 1,
            },
            borderRadius: 2,
          }}
        >
          {isGettingFaucet ? (
            <Oval
              visible={true}
              height="20"
              width="20"
              color="#648DFFD9"
              ariaLabel="oval-loading"
              strokeWidthSecondary={10}
              strokeWidth={10}
              secondaryColor="white"
            />
          ) : (
            'Request'
          )}
        </Button>
      </Box>
      {txhash && (
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          Faucet request was success! See{' '}
          <a
            href={getTxExplorer(txhash)}
            target="_blank"
            style={{ textDecoration: 'none', color: '#648DFF' }}
          >
            details
          </a>
          .
        </Box>
      )}
    </Container>
  );
};

export default Faucet;
